import { createFileRoute } from "@tanstack/react-router";
import ServiceGoogleAds from "@/pages/ServiceGoogleAds";
import {
  buildPageHead,
  breadcrumbSchema,
  serviceSchema,
  faqPageSchema,
} from "@/lib/seo";

const faqs = [
  {
    question: "What does a Google Ads performance specialist do?",
    answer:
      "A Google Ads performance specialist designs and scales the complete ad infrastructure: Enhanced Conversions tracking, keyword and account-structure architecture, Smart Bidding frameworks, profitable scaling logic, and profitability dashboards. They engineer the system, not just buy media.",
  },
  {
    question: "Can you fix unreliable Google Ads conversion tracking?",
    answer:
      "Yes. I implement Google Ads Enhanced Conversions with server-side event routing and first-party data so your Smart Bidding signals reconcile with your actual revenue, replacing unreliable tag-only reporting.",
  },
  {
    question: "How do you scale Google Ads without breaking profitability?",
    answer:
      "Every account I architect uses MER-based guardrails and budget-pacing automation. Scaling triggers only fire when marketing efficiency ratio holds, so CPA stays protected as spend grows from 5x to 50x.",
  },
  {
    question: "How much does a Google Ads specialist cost?",
    answer:
      "Engagements are scoped per project or retainer. A senior ads specialist delivers the full tracking and scaling architecture at a fraction of a US agency rate. Book a free ads audit call to receive a custom scope and quote.",
  },
];

export const Route = createFileRoute("/google-ads-performance-specialist")({
  head: () =>
    buildPageHead({
      title: "Google Ads Performance Specialist & Enhanced Conversions Expert",
      description:
        "Hire a dedicated Google Ads Performance Specialist. Enhanced Conversions tracking, account-structure architecture, Smart Bidding frameworks, and profitable scaling logic for brands that refuse to waste ad spend.",
      path: "/google-ads-performance-specialist",
      keywords:
        "Google Ads specialist, Google Ads expert, Enhanced Conversions, Google Ads expert Philippines, paid ads performance specialist, Smart Bidding framework, ad scaling, MER ROAS, hire Google Ads specialist",
      schema: [
        serviceSchema({
          name: "Google Ads Performance Architecture & Conversion Tracking",
          description:
            "Enhanced Conversions tracking, account-structure architecture, Smart Bidding frameworks, and profitable scaling logic for scaling brands.",
          path: "/google-ads-performance-specialist",
          serviceType: [
            "Google Ads Architecture",
            "Enhanced Conversions Implementation",
            "Smart Bidding Frameworks",
            "Profitable Scaling Logic",
          ],
        }),
        breadcrumbSchema([
          { name: "Home", path: "" },
          {
            name: "Google Ads Performance Specialist",
            path: "/google-ads-performance-specialist",
          },
        ]),
        faqPageSchema(faqs),
      ],
    }),
  component: ServiceGoogleAds,
});
